import { TSPAY_CONFIG_NEW_URL, TSPAY_START_ONBOARDING, RESEND_TSPAY_ONBOARDING_MAIL_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const onboardingConstants = {
  GET_TSPAY_CONFIG_STATUS_START: "GET_TSPAY_CONFIG_STATUS_START",
  GET_TSPAY_CONFIG_STATUS_SUCCESS: "GET_TSPAY_CONFIG_STATUS_SUCCESS",
  GET_TSPAY_CONFIG_STATUS_ERROR: "GET_TSPAY_CONFIG_STATUS_ERROR",

  POST_TSPAY_ONBOARDING_SESSION_START: "POST_TSPAY_ONBOARDING_SESSION_START",
  POST_TSPAY_ONBOARDING_SESSION_SUCCESS: "POST_TSPAY_ONBOARDING_SESSION_SUCCESS",
  POST_TSPAY_ONBOARDING_SESSION_ERROR: "POST_TSPAY_ONBOARDING_SESSION_ERROR",

  POST_RESEND_ONBOARDING_MAIL_START: "POST_RESEND_ONBOARDING_MAIL_START",
  POST_RESEND_ONBOARDING_MAIL_SUCCESS: "POST_RESEND_ONBOARDING_MAIL_SUCCESS",
  POST_RESEND_ONBOARDING_MAIL_ERROR: "POST_RESEND_ONBOARDING_MAIL_ERROR"
};

export function getTsPayConfigStatus(auth, itemId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: onboardingConstants.GET_TSPAY_CONFIG_STATUS_START
      });

      if (!itemId) reject();

      let request = {
        method: "get",
        url: `${TSPAY_CONFIG_NEW_URL}/config/${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: onboardingConstants.GET_TSPAY_CONFIG_STATUS_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: onboardingConstants.GET_TSPAY_CONFIG_STATUS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function startTsPayOnboardingSession() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_START
      });

      let request = {
        method: "post",
        url: `${TSPAY_START_ONBOARDING}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          itemId: itemId
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function resendOnboardingMail(auth, itemId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: onboardingConstants.POST_RESEND_ONBOARDING_MAIL_START
      });

      let request = {
        method: "post",
        url: `${RESEND_TSPAY_ONBOARDING_MAIL_URL}/generateApiKey/${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: onboardingConstants.POST_RESEND_ONBOARDING_MAIL_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: onboardingConstants.POST_RESEND_ONBOARDING_MAIL_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
